import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SecurityService } from '../pages/authentication/services/security.service';

@Injectable({
    providedIn: 'root'
})
export class ValidateTokenGuard  {
    
    constructor(private securityService: SecurityService, private router: Router) { }

    canActivate(): Observable<boolean> | boolean {
        return this.securityService.validateToken();
    }
    
    canLoad(): Observable<boolean> | boolean {
        return this.securityService.validateToken();
    }

}